import { acceptHMRUpdate, defineStore } from 'pinia'
import { ref, shallowRef } from 'vue'

import { bookingsApi } from '@/api/client'
import type { GetLocations200ResponseInner } from '@/openapi'

export const useAuthStore = defineStore('auth', () => {
  const organizationId = ref<string | null>(null)
  const locationId = ref<string | null>(null)

  const organizationLocations = shallowRef<GetLocations200ResponseInner[] | null>(null)

  function setLocationId(id: string) {
    locationId.value = id
  }

  function setOrganizationId(id: string) {
    organizationId.value = id
  }

  async function getOrganizationLocations() {
    if (!organizationId.value) return
    organizationLocations.value = await bookingsApi.getLocations()
  }

  return {
    locationId,
    organizationId,
    organizationLocations,
    setLocationId,
    setOrganizationId,
    getOrganizationLocations
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAuthStore, import.meta.hot))
}
